import {
  createGroupMessage as createGroupMessageService,
  getGroupMessageById as getGroupMessageByIdService,
  createTopic as createTopicService,
  getTopicById as getTopicByIdService,
  createBroadcast as createBroadcastService,
  removeGroupMessage as removeGroupMessageService,
  getTopicsAndMessages,
  updateTopic as updateTopicService,
} from '../../services/messagingService';
import {
  getPreSignedUrlForUpload,
  uploadFileToS3,
  getPreSignedUrlForDownload,
} from '../../services/fileService';
import {
  FB_MESSAGING_GROUP_CHAT_GET_FAILURE,
  FB_MESSAGING_GROUP_CHAT_GET_REQUEST,
  FB_MESSAGING_GROUP_CHAT_GET_SUCCESS,
  FB_MESSAGING_TOPIC_GET_FAILURE,
  FB_MESSAGING_TOPIC_GET_REQUEST,
  FB_MESSAGING_TOPIC_GET_SUCCESS,
  MESSAGING_GROUP_CHAT_ADD_FAILURE,
  MESSAGING_GROUP_CHAT_ADD_REQUEST,
  MESSAGING_GROUP_CHAT_ADD_SUCCESS,
  MESSAGING_TOPIC_ADD_FAILURE,
  MESSAGING_TOPIC_ADD_REQUEST,
  MESSAGING_TOPIC_ADD_SUCCESS,
  SET_CURRENT_TOPIC_ID,
  // MESSAGING_TOPIC_DIRTY,
  // MESSAGING_TOPIC_CLEAN,
  RESET_MESSAGING_STATE,
  RESET_TOPIC_STATE,
  MESSAGING_GROUP_CHAT_PRE_SIGN_URL_FOR_UPLOAD_REQUEST,
  MESSAGING_GROUP_CHAT_PRE_SIGN_URL_FOR_UPLOAD_SUCCESS,
  MESSAGING_GROUP_CHAT_PRE_SIGN_URL_FOR_UPLOAD_FAILURE,
  MESSAGING_GROUP_CHAT_UPLOAD_FILE_REQUEST,
  MESSAGING_GROUP_CHAT_UPLOAD_FILE_SUCCESS,
  MESSAGING_GROUP_CHAT_UPLOAD_FILE_FAILURE,
  MESSAGING_GROUP_CHAT_PRE_SIGN_URL_FOR_DOWNLOAD_REQUEST,
  MESSAGING_GROUP_CHAT_PRE_SIGN_URL_FOR_DOWNLOAD_SUCCESS,
  MESSAGING_GROUP_CHAT_PRE_SIGN_URL_FOR_DOWNLOAD_FAILURE,
  SET_CURRENT_MESSAGE_ID,
  MESSAGING_BROADCAST_ADD_REQUEST,
  MESSAGING_BROADCAST_ADD_SUCCESS,
  MESSAGING_BROADCAST_ADD_FAILURE,
  MESSAGING_GROUP_CHAT_REMOVE_REQUEST,
  MESSAGING_GROUP_CHAT_REMOVE_SUCCESS,
  MESSAGING_GROUP_CHAT_REMOVE_FAILURE,
  FB_REMOVE_GROUP_MESSAGE,
  MESSAGING_SET_NAV_MODE,
  TOPICS_GET_BY_USER_REQUEST,
  TOPICS_GET_BY_USER_SUCCESS,
  TOPICS_GET_BY_USER_FAILURE,
  MESSAGING_TOPIC_UPDATE_REQUEST,
  MESSAGING_TOPIC_UPDATE_SUCCESS,
  MESSAGING_TOPIC_UPDATE_FAILURE,
  MESSAGING_BROADCAST_TAPPED,
} from '../../actions/actionTypes';
import {
  GROUP_MESSAGE_FILE_DOWNLOAD,
  GROUP_MESSAGE_FILE_UPLOAD,
} from '../../constants/fileResources';

import { getCurrentEmployer } from '../../selectors/employers';
import { getCurrentTopic } from './selector';

import { Navigation } from '../components';

import navModes from './nav_modes';
import { MESSAGING_NEW_GROUP_MESSAGE_NOTIFICATION } from '../../notificationsHandlersTypes';
import { markNotificationAsRead } from '../notifications/actions';

import { imageExt } from '../../helpers/images';

let pendingCurrentTopicId = null;
import { MESSAGING_TAB } from '../../constants/tabs';

export function handlePushReceived(notification) {
  return function (dispatch, getState) {
    if (Navigation.getActiveTabNum() !== MESSAGING_TAB) return false;
    const state = getState();
    const currentTopic = getCurrentTopic(state);
    if (!currentTopic) return false;

    const data = notification.data;
    const resource = notification.data.resource;

    let handled = false;
    switch (resource) {
      case MESSAGING_NEW_GROUP_MESSAGE_NOTIFICATION:
        handled = data.topicId == currentTopic.topicId;
        break;
    }
    if (handled) {
      dispatch(markNotificationAsRead(data.notificationId));
    }
    return handled;
  };
}

export function setNavMode(mode) {
  return function (dispatch, getState) {
    const navMode = getState().screens.messaging.navMode;
    if (navMode !== mode) {
      return dispatch({ type: MESSAGING_SET_NAV_MODE, payload: mode });
    }
  };
}

export function createBroadcast(employerId, caseIds, message) {
  return {
    types: [
      MESSAGING_BROADCAST_ADD_REQUEST,
      MESSAGING_BROADCAST_ADD_SUCCESS,
      MESSAGING_BROADCAST_ADD_FAILURE,
    ],
    promise: createBroadcastService(employerId, caseIds, message),
  };
}

export function createGroupMessage(message, topicId, caseId, employerId) {
  return function (dispatch, getState) {
    const state = getState();
    if (!(topicId && (caseId || employerId))) {
      const currentTopic = getCurrentTopic(state);
      if (!currentTopic) return;
      caseId = currentTopic.caseId;
      employerId = currentTopic.employerId;
      topicId = currentTopic.topicId;
    }

    dispatch({
      types: [
        MESSAGING_GROUP_CHAT_ADD_REQUEST,
        MESSAGING_GROUP_CHAT_ADD_SUCCESS,
        MESSAGING_GROUP_CHAT_ADD_FAILURE,
      ],
      promise: createGroupMessageService(
        topicId,
        {
          ...message,
          topicId,
          userId: state.user.userId,
        },
        { caseId, employerId }
      ),
    });
  };
}

export function getGroupMessageById(topicId, messageId, caseId, employerId) {
  return function (dispatch, getState) {
    dispatch({
      types: [
        FB_MESSAGING_GROUP_CHAT_GET_REQUEST,
        FB_MESSAGING_GROUP_CHAT_GET_SUCCESS,
        FB_MESSAGING_GROUP_CHAT_GET_FAILURE,
      ],
      promise: getGroupMessageByIdService(topicId, messageId, caseId, employerId),
    });
  };
}

export function removeGroupMessage(messageId) {
  return function (dispatch, getState) {
    const currentTopic = getCurrentTopic(getState());
    if (!currentTopic) return;
    const caseId = currentTopic.caseId;
    const employerId = currentTopic.employerId;
    const topicId = currentTopic.topicId;
    dispatch({
      types: [
        MESSAGING_GROUP_CHAT_REMOVE_REQUEST,
        MESSAGING_GROUP_CHAT_REMOVE_SUCCESS,
        MESSAGING_GROUP_CHAT_REMOVE_FAILURE,
      ],
      promise: removeGroupMessageService(topicId, messageId, caseId, employerId),
    });
  };
}

export function setCurrentMessage(currentMessageId) {
  return { type: SET_CURRENT_MESSAGE_ID, payload: currentMessageId };
}

export function changeCurrentTopic(topicId, currentMessageId) {
  return function (dispatch, getState) {
    const state = getState();
    let payload = {};
    let navMode = state.screens.messaging.navMode;

    let correctNavMode;
    const topic = state.entities.topics[topicId];
    // we might not have the topic if we've clicked on a message push notification
    // before we've pulled the topics and messages from the server
    if (topic) {
      if (topic.caseId) correctNavMode = navModes.CASE;
      else if (topic.name !== '_') correctNavMode = navModes.ONCALL;
      else correctNavMode = navModes.EMPLOYER;

      if (navMode !== correctNavMode) {
        navMode = correctNavMode;
        dispatch({ type: MESSAGING_SET_NAV_MODE, payload: navMode });
      }
    } else {
      // save it off to call changeCurrentTopic with after pulling topics and messages
      pendingCurrentTopicId = topicId;
      return;
    }

    if (navMode === navModes.CASE) {
      payload = { currentTopicId: topicId, currentMessageId };
    } else if (navMode === navModes.EMPLOYER) {
      payload = { currentEmployerTopicId: topicId, currentMessageId };
    } else if (navMode === navModes.ONCALL) {
      payload = { currentOnCallTopicId: topicId, currentMessageId };
    }

    dispatch({
      type: SET_CURRENT_TOPIC_ID,
      payload,
    });
  };
}

export function fetchTopicsAndMessage() {
  return async function (dispatch, getState) {
    if (!getState().user.userId) return;
    await dispatch({
      types: [TOPICS_GET_BY_USER_REQUEST, TOPICS_GET_BY_USER_SUCCESS, TOPICS_GET_BY_USER_FAILURE],
      promise: getTopicsAndMessages(),
    });
    const currentTopicId = pendingCurrentTopicId;
    pendingCurrentTopicId = null;
    currentTopicId && dispatch(changeCurrentTopic(currentTopicId));
  };
}

function numSorter(a, b) {
  return parseInt(a) - parseInt(b);
}
// find a topic for this case or employer with the same name and set of members as in
// topicObj
function _findExistingTopicId(topics, topicObj, caseId, employerId) {
  const topicKey = Object.keys(topics).find((k) => {
    const topic = topics[k];
    if (topic.caseId !== caseId && topic.employerId !== employerId) return false;
    if (topic.name !== topicObj.name) return false;
    const topicMembers = (topic.members || []).slice(0).sort(numSorter).join(',');
    const topicObjMembers = topicObj.members
      .map((m) => m.userId)
      .sort(numSorter)
      .join(',');
    return topicMembers === topicObjMembers;
  });
  return topicKey ? parseInt(topicKey) : null;
}
export function createTopic(topicObj) {
  return function (dispatch, getState) {
    const state = getState();
    let caseId, employerId;
    if (state.screens.messaging.navMode === navModes.CASE) {
      caseId = state.application.currentCaseId;
    } else if (state.screens.messaging.navMode === navModes.EMPLOYER) {
      employerId = getCurrentEmployer(state)?.employerId;
    } else {
      // there is no creation of topics in oncall mode
      return Promise.reject();
    }
    const existingTopicId = _findExistingTopicId(
      state.entities.topics,
      topicObj,
      caseId,
      employerId
    );
    if (existingTopicId) {
      dispatch(changeCurrentTopic(existingTopicId, null));
      return;
    }
    dispatch({
      types: [
        MESSAGING_TOPIC_ADD_REQUEST,
        MESSAGING_TOPIC_ADD_SUCCESS,
        MESSAGING_TOPIC_ADD_FAILURE,
      ],
      promise: createTopicService(topicObj, { caseId, employerId }).then((response) => {
        return response;
      }),
    });
  };
}

export function updateTopic(topicObj) {
  return function (dispatch, getState) {
    const currentTopic = getCurrentTopic(getState());
    if (!currentTopic) return;
    const caseId = currentTopic.caseId;
    const employerId = currentTopic.employerId;
    const topicId = currentTopic.topicId;
    dispatch({
      types: [
        MESSAGING_TOPIC_UPDATE_REQUEST,
        MESSAGING_TOPIC_UPDATE_SUCCESS,
        MESSAGING_TOPIC_UPDATE_FAILURE,
      ],
      promise: updateTopicService(topicId, topicObj, { caseId, employerId }).then((response) => {
        return response;
      }),
    });
  };
}

export function getTopicById(topicId, { caseId, employerId }) {
  return function (dispatch, getState) {
    dispatch({
      types: [
        FB_MESSAGING_TOPIC_GET_REQUEST,
        FB_MESSAGING_TOPIC_GET_SUCCESS,
        FB_MESSAGING_TOPIC_GET_FAILURE,
      ],
      promise: getTopicByIdService(topicId, { caseId, employerId }).then((response) => {
        return response;
      }),
    });
  };
}

// export function setStateDirty(isDirty) {
//   return function(dispatch, getState) {
//     // If you remove this and use return instead of dispatch should work also.
//     console.log('setStateDirty');
//     if (isDirty) dispatch({ type: MESSAGING_TOPIC_DIRTY });
//     else dispatch({ type: MESSAGING_TOPIC_CLEAN });
//   };
// }

export function resetState() {
  return function (dispatch) {
    dispatch({ type: RESET_MESSAGING_STATE });
  };
}

export function resetTopicState() {
  return function (dispatch) {
    dispatch({ type: RESET_TOPIC_STATE });
  };
}

function getPreSignedUrlForGroupMessageUpload(topicId, extension) {
  const preSignedUrlObj = {
    resource: GROUP_MESSAGE_FILE_UPLOAD,
    fileExtension: extension,
    objectId: topicId,
  };
  return {
    types: [
      MESSAGING_GROUP_CHAT_PRE_SIGN_URL_FOR_UPLOAD_REQUEST,
      MESSAGING_GROUP_CHAT_PRE_SIGN_URL_FOR_UPLOAD_SUCCESS,
      MESSAGING_GROUP_CHAT_PRE_SIGN_URL_FOR_UPLOAD_FAILURE,
    ],
    promise: getPreSignedUrlForUpload(preSignedUrlObj),
    throwError: true,
  };
}

function uploadGroupMessageImageToS3(url, image, isHeic, isMov) {
  return {
    types: [
      MESSAGING_GROUP_CHAT_UPLOAD_FILE_REQUEST,
      MESSAGING_GROUP_CHAT_UPLOAD_FILE_SUCCESS,
      MESSAGING_GROUP_CHAT_UPLOAD_FILE_FAILURE,
    ],
    promise: uploadFileToS3(url, image, isHeic, isMov),
    throwError: true,
  };
}

export function uploadImageAndCreateGroupMessage(imageData, message) {
  return async function (dispatch, getState) {
    let extension;
    try {
      extension = await imageExt(imageData);
    } catch (e) {
      dispatch({ type: MESSAGING_GROUP_CHAT_ADD_FAILURE, payload: e });
    }

    let isHeic = extension === 'heic';
    let isMov = extension === 'mov';
    const newExt = (isHeic && 'jpg') || (isMov && 'mp4') || extension;

    const currentTopic = getCurrentTopic(getState());
    if (!currentTopic) return;

    const caseId = currentTopic.caseId;
    const employerId = currentTopic.employerId;
    const topicId = currentTopic.topicId;

    return dispatch(getPreSignedUrlForGroupMessageUpload(topicId, newExt)).then(() => {
      const fileName = getState().screens.messaging.signedImageName;
      const signedUrl = getState().screens.messaging.signedUploadUrl;

      dispatch(uploadGroupMessageImageToS3(signedUrl, imageData, isHeic, isMov)).then(() => {
        message.fileName = fileName;
        dispatch(createGroupMessage(message, topicId, caseId, employerId));
      });

      return fileName;
    });
  };
}

function getPreSignedUrlForGroupMessageDownload(messageId) {
  const preSignedUrlObj = {
    resource: GROUP_MESSAGE_FILE_DOWNLOAD,
    objectId: messageId,
  };
  return {
    types: [
      MESSAGING_GROUP_CHAT_PRE_SIGN_URL_FOR_DOWNLOAD_REQUEST,
      MESSAGING_GROUP_CHAT_PRE_SIGN_URL_FOR_DOWNLOAD_SUCCESS,
      MESSAGING_GROUP_CHAT_PRE_SIGN_URL_FOR_DOWNLOAD_FAILURE,
    ],
    promise: getPreSignedUrlForDownload(preSignedUrlObj),
  };
}

export function removeGroupMessageLocally(topicId, messageId) {
  return function (dispatch, getState) {
    // If we removed already don't do anything
    if (getState().entities.topics[topicId]?.messages[messageId]) {
      const payload = { topicId, messageId };
      dispatch({ type: FB_REMOVE_GROUP_MESSAGE, payload });
    }
  };
}

export function brodcastNotificationTapped() {
  return function (dispatch, getState) {
    return dispatch({ type: MESSAGING_BROADCAST_TAPPED });
  };
}
